import { DeprecatedSelectField, type DeprecatedDropdownMenuOption } from "@octopusdeploy/design-system-octopus-components";
import styles from "~/areas/infrastructure/components/DeploymentTargets/style.module.less";
export enum DeploymentTargetDeploymentsGrouping {
    None = "No Grouping",
    ByProject = "By Project"
}
export interface DeploymentTargetDeploymentsGroupingMenuProps {
    grouping: DeploymentTargetDeploymentsGrouping;
    onChange: (grouping: DeploymentTargetDeploymentsGrouping) => void;
}
export const DeploymentTargetDeploymentsGroupingMenu = ({ grouping, onChange }: DeploymentTargetDeploymentsGroupingMenuProps) => {
    const groupingMenuItems: DeprecatedDropdownMenuOption[] = [
        { value: DeploymentTargetDeploymentsGrouping.None, text: DeploymentTargetDeploymentsGrouping.None, onChange: () => onChange(DeploymentTargetDeploymentsGrouping.None) },
        { value: DeploymentTargetDeploymentsGrouping.ByProject, text: DeploymentTargetDeploymentsGrouping.ByProject, onChange: () => onChange(DeploymentTargetDeploymentsGrouping.ByProject) },
    ];
    return (<div className={styles.groupByMenu}>
            <DeprecatedSelectField className={styles.groupByMenu} placeholder="Group by" value={grouping} items={groupingMenuItems}/>
        </div>);
};
